<template>
  <div
    :class="cssClasses"
    @click="toggle"></div>
</template>

<script>
export default {
  name: 'switcher',
  props: {
    value: {
      type: [Number, Boolean],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      state: false
    }
  },
  watch: {
    value (newValue) {
      this.state = !!newValue;
    }
  },
  computed: {
    cssClasses () {
      return {
        'switcher': true,
        'is-active': this.state,
        'is-disabled': this.disabled,
        'is-small': this.isSmall
      };
    }
  },
  mounted () {
    this.state = !!this.value;
    this.$emit('input', this.state);
  },
  methods: {
    toggle () {
      this.state = !this.state;
      this.$emit('input', this.state);
    },
    getValue () {
      return this.state;
    },
    setValue (newValue) {
      this.state = newValue;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.switcher {
  background: $color-border;
  border-radius: 1rem;
  cursor: pointer;
  height: 2rem;
  margin: .6rem 0;
  position: relative;
  transition: all .25s ease-out;
  width: 4rem;

  + * {
    margin-left: 2rem;
  }

  &:before {
    background: $color-light;
    border-radius: $border-radius-full;
    content: "";
    height: 1.6rem;
    left: .2rem;
    position: absolute;
    top: .2rem;
    transition: all .25s ease-out;
    width: 1.6rem;
  }

  &.is-active {
    background: $color-success;

    &:before {
      left: 2.2rem;
    }

    &.is-small {
      &:before {
        left: 1rem;
      }
    }
  }

  &.is-disabled {
    opacity: .4;
    pointer-events: none;
  }

  &.is-small {
    border-radius: .8rem;
    cursor: pointer;
    height: 1.6rem;
    margin: .1rem 0;
    width: 2.4rem;

    + * {
      margin-left: 1rem;
    }

    &:before {
      content: "";
      height: 1.2rem;
      left: .2rem;
      top: .2rem;
      width: 1.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Switcher.vue